export default __webpack_public_path__ + "static/media/faktory_branco.dd7528d9.svg";